export const actionType = {
  SELECT_MENU_ITEM: 'MENU/SELECT_MENU_ITEM',
};
